import { render } from "./billing-customers.vue?vue&type=template&id=0d2f3703&scoped=true"
import script from "./billing-customers.vue?vue&type=script&lang=js"
export * from "./billing-customers.vue?vue&type=script&lang=js"

import "./billing-customers.vue?vue&type=style&index=0&id=0d2f3703&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2f3703"]])

export default __exports__